import Alerts from "../Alerts/Alerts";

const DesktopAlerts = ({ currentUser, onCount, onChatCount, onNavigate }) => (
  <div className="d-page">
    <div className="d-container-sm">
      <Alerts
        currentUser={currentUser}
        onCount={onCount}
        onChatCount={onChatCount}
        onNavigate={onNavigate}
      />
    </div>
  </div>
);

export default DesktopAlerts;
